import { z } from 'zod'

import { baseVanillaSchema } from '@/pages/instruments/new-instrument/schemas/shared/base-vanilla.schema'
import { contractTypeSchema } from '@/pages/instruments/new-instrument/schemas/shared/contract-type.schema'
import { knockdownInputLevelSchema } from '@/pages/instruments/new-instrument/schemas/shared/knockdown-input-level.schema'
import { sideSchema } from '@/pages/instruments/new-instrument/schemas/shared/side.schema'

export const vanillaDigitalSchema = baseVanillaSchema.extend({
  instrument_type: z.literal('vanilla-digital'),
  contract_type: contractTypeSchema,
  side: sideSchema,
  coupon_rate_annual: z.number(),
  payoff_barrier_level: z.number(),
  knockdown_input_level: knockdownInputLevelSchema,
})

export type VanillaDigitalSchemaType = z.infer<typeof vanillaDigitalSchema>
